export default () => {
  $('#offcanvasRight').on('click', '.add_contact_person', function(event) {
    dirty = true

    var regexp, time
    time = new Date().getTime()
    regexp = new RegExp($(this).data('id'), 'g')
    $(this).closest('.tab-pane').find('.contact_person_rows').append($(this).data('fields').replace(regexp, time))
    
    if ($(this).closest('.tab-pane').find('.contact_person_rows .contact_person:not(.d-none)').length === 1) {
      $(this).closest('.tab-pane').find('.contact_person_rows .contact_person').last().find('.select_main_contact').prop('checked', true)
    }

    $(this).blur()

    return event.preventDefault()
  })

  $('#offcanvasRight').on('click', '.remove_contact_person_row', function(event) {
    dirty = true

    $(this).prev('input[type=hidden]').val('1')
    $(this).closest('.row').addClass('d-none')
    $(this).closest('.contact_person_rows').find('.row').not('.d-none').last().find('.hr').addClass('d-none')

    return event.preventDefault()
  })
  
  $('#offcanvasRight').on('change', '.contact_person_rows .select_main_contact', function(event) {
    if ($(this).is(':checked')) {
      $('#contact-people .select_main_contact').prop('checked', false)
      $('#contact-people .contact_person_rows .remove_contact_person_row').removeClass('d-none')
    }
    $(this).prop('checked', true)
    $(this).closest('.contact_person').find('.remove_contact_person_row').addClass('d-none')
  })
}